/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    AvailableJiraProject,
    AvailableJiraProjectFromJSON,
    AvailableJiraProjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface AvailableJiraProjects
 */
export interface AvailableJiraProjects {
    /**
     * 
     * @type {Array<AvailableJiraProject>}
     * @memberof AvailableJiraProjects
     */
    projects: Array<AvailableJiraProject>;
}

export function AvailableJiraProjectsFromJSON(json: any): AvailableJiraProjects {
    return {
        
        'projects': (json['projects'] as Array<any>).map(AvailableJiraProjectFromJSON),
        
    };
}

export function AvailableJiraProjectsToJSON(value?: AvailableJiraProjects): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'projects': (value.projects as Array<any>).map(AvailableJiraProjectToJSON),
        
    };
}


